import React from 'react';
import { ArrowheadDefs, ConnectionPreview } from '../../EdgeRenderer';

const ConnectionPreviewLayer = ({
  connectingFrom,
  connectingTarget,
  connectingBranch,
  connectingStartPos,
  displayPositions,
  nodeDimensions,
  mousePos,
  tasks,
}) => (
  <svg className="flowchart__edges flowchart__edges--preview">
    <ArrowheadDefs />
    <ConnectionPreview
      connectingFrom={connectingFrom}
      connectingTarget={connectingTarget}
      connectingBranch={connectingBranch}
      connectingStartPos={connectingStartPos}
      nodePositions={displayPositions}
      nodeDimensions={nodeDimensions}
      mousePos={mousePos}
      tasks={tasks}
    />
  </svg>
);

export default ConnectionPreviewLayer;
